export default __webpack_public_path__ + "static/media/close.c9508943.svg";